import { useMemo } from 'react';
import { getLocalToday } from '../config/timezone';

// Memoizzato per la vita del componente: senza questo `getLocalToday()` ritorna
// un nuovo Date a ogni render → un useEffect con `today` nelle deps si ri-esegue
// di continuo. È esattamente ciò che impediva di selezionare lo stato REJECTED
// in goods-receiving (l'effect resettava `status` a ogni render).
export function useToday(): Date {
  return useMemo(() => getLocalToday(), []);
}
